import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faFolder, faXmark } from '@fortawesome/free-solid-svg-icons';

//STYLE
import { OrdenacaoContainer } from './styled';

//APP
import { opcoesArquivos } from '../../../meta';

//COMPONENTS
import ButtonCustom from '../../../../../../../../../../../../../../../../../Components/ButtonCustom';
import { Box } from '../../../../../../../../../../../../../../../../../Components/CustomUi/box';
import { Render } from '../../../../../../../../../../../../../../../../../Components/CustomUi/render';
import { Select } from '../../../../../../../../../../../../../../../../../Components/CustomUi/Select';

interface PropsOrdenacao {
    selecionarPonto: boolean
    setSelecionarPonto: React.Dispatch<React.SetStateAction<boolean>>
    arquivoSelecionado: string
    setArquivoSelecionado: React.Dispatch<React.SetStateAction<string>>
    pontosSelecionados: any[]
    resetarGrid: Function
}

export const AbaOrdenacao: React.FC<PropsOrdenacao> = React.memo(({
    selecionarPonto,
    setSelecionarPonto,
    arquivoSelecionado,
    setArquivoSelecionado,
    pontosSelecionados,
    resetarGrid,
}) => {
    const [openOpcao, setOpenOpcao] = useState<boolean>(false)

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontWeight: '500', fontSize: '13px' }}>Ordenação dos pontos</label>
            <Box>
                <OrdenacaoContainer>
                    <div
                        style={{
                            display: 'flex',
                            textAlign: 'center',
                            alignItems: 'center',
                            gap: '5px',
                        }}
                    >
                        <div className='circle'></div> -{' '}
                        <span style={{ padding: 0, margin: 0, fontSize: '11px' }}>
                            Mostra que o ponto 1 foi selecionado
                        </span>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            textAlign: 'center',
                            alignItems: 'center',
                            gap: '5px',
                        }}
                    >
                        <div className='linha'></div> -{' '}
                        <span style={{ padding: 0, margin: 0, fontSize: '11px' }}>
                            Mostra a direção da ordenação
                        </span>
                    </div>
                </OrdenacaoContainer>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <ButtonCustom
                        style={{
                            fontSize: '12px',
                            backgroundColor: selecionarPonto ? '#5DA57D' : 'white',
                            color: selecionarPonto ? 'white' : '#5DA57D',
                        }}
                        type='secondary'
                        onClick={() => setSelecionarPonto(true)}
                        icon={<FontAwesomeIcon fontSize={18} icon={faCheck} />}
                    >
                        Selecionar
                    </ButtonCustom>

                    <ButtonCustom
                        danger
                        onClick={() => {
                            setSelecionarPonto(false)
                            resetarGrid()
                        }}
                        icon={<FontAwesomeIcon icon={faXmark} />}
                    >
                        Resetar
                    </ButtonCustom>
                </div>
            </Box>
            <Render condition={pontosSelecionados?.length > 1}>
                <div style={{ height: '120px', marginTop: '10px' }}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <Select
                            value={arquivoSelecionado}
                            onChange={setArquivoSelecionado}
                            open={openOpcao}
                            trigger={setOpenOpcao}
                            items={opcoesArquivos}
                            descricaoItem={'nome'}
                            idItem={'id'}
                            icon={faFolder}
                            label='Tipo de arquivo'
                            placeholder='Selecione o tipo do arquivo'
                        />
                    </motion.div>
                </div>
            </Render>
        </div>
    )
})
